export default [
  {
    path: "audit",
    name: "audit",
    component: (): Promise<any> => import(/* webpackChunkName: "audit" */ "@/views/Admin/AuditView.vue")
  }
];
